import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Zoomist from '../../../vendorjs/zoomist/zoomist.vendor';
export var ImageComponentBehavior = function ImageComponentBehavior() {
  Alpine.data('ImageComponentBehavior', function () {
    return {
      $zoom: false,
      init: function init() {
        this.$zoom = this.$el;
        this.zoom = new Zoomist(this.$zoom, {
          height: '75%',
          slider: true,
          zoomer: true,
          fill: 'cover',
          bounds: true,
          maxRatio: 5,
          wheelable: true,
          pinchable: true
        });
      }
    };
  });
};